import { Link } from 'react-router-dom';

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-0">
          <div className="lg:w-3/5 flex flex-col justify-center">
            <p className="text-foreground-400 text-sm font-medium uppercase tracking-wider mb-6">
              SEO Resource Center
            </p>
            <blockquote className="font-heading text-xl md:text-2xl lg:text-3xl text-foreground-950 leading-relaxed italic max-w-lg mb-6">
              &ldquo;The pandabuyspreadsheet approach transforms how people evaluate products online.
              Instead of relying on scattered information, you get clean, structured data that makes
              comparison effortless and decisions smarter.&rdquo;
            </blockquote>
            <div className="flex items-center gap-4">
              <span className="font-medium text-foreground-900 text-sm">Pandabuy Editorial</span>
              <span className="flex items-center gap-1 text-accent-500">
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
              </span>
            </div>
            <div className="mt-8">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-foreground-600 text-sm hover:text-foreground-900 transition-colors cursor-pointer"
              >
                <span>Back to PandabuySpreadsheet Home</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
          <div className="lg:w-2/5">
            <div className="relative h-80 md:h-96 lg:h-[450px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Closeup%20artistic%20photograph%20of%20stylish%20leather%20bag%20with%20gold%20hardware%20resting%20on%20textured%20dark%20slate%20with%20dramatic%20single%20light%20source%20creating%20theatrical%20shadows%20luxury%20editorial%20black%20and%20white%20photography%20timeless%20sophisticated%20aesthetic&width=800&height=1100&seq=testimonial-v2&orientation=portrait"
                alt="PandabuySpreadsheet editorial product photography"
                className="w-full h-full object-cover object-top"
                title="PandabuySpreadsheet - Editorial Product Showcase"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}